import { CSVExport } from 'react-bootstrap-table2-toolkit';
const { ExportCSVButton } = CSVExport;

const CustomExportCSVButton = ({ applyCustomOnClick, onClick, children, className, ...rest }) => {

    return (
        applyCustomOnClick ?
            (<button type="button" className={className} onClick={onClick}>
                {children}
            </button>)
        :
            (<ExportCSVButton className={className} {...rest}>
                {children}
            </ExportCSVButton>)
    )
}

export default CustomExportCSVButton;
